export default {
	label: 'Töölaud',
	approachingDueDate: 'Tähtajale lähenevad meetmed',
	duedateMethods: 'Meetmete tähtajani staatused',
	byModules: 'Mooduli kaupa',
	overallChart: 'Üldine seisund',
	total: 'Kokku',
}
